import React, { useContext, useRef } from 'react'
import styles from '../styles.module.scss'
import Button from '../../../components/Button'
import { DisciplineStructureContext } from '../../../utils/context'
import { useNavigate } from 'react-router-dom'


export default function Footer() {

  const { editRow, saveData, selectedRow, buttonsBlockRef, createRow, deleteRow, tableData, form } = useContext(DisciplineStructureContext)
  const navigate = useNavigate()
  const filePicker = useRef()

  const goBack = () => navigate(-1)

  const canAddChild = selectedRow && selectedRow.oid > 0



  // ............Excel.................
  const flattenData = (data, result = [], level = 0) => {
    data.forEach(row => {
      const indent = '  '.repeat(level)
      result.push({
        'Название': indent + (row.title || ''),
        'Модуль': row.module || '',
        'Часы': row.hrs || '',
        'Номер': row.nr || '',
        'Ожидаемый результат': row.expected_result || '',
        'Упражнения': row.exercises || '',
        'Позиция': row.position || ''
      })
      if (row.children && row.children.length > 0) {
        flattenData(row.children, result, level + 1)
      }
    })
    return result
  }

  const exportToExcel = () => {
    if (!tableData || tableData.length === 0) {
      alert('Нет данных для экспорта')
      return
    }

    try {
      // Подготавливаем данные
      const flatData = flattenData(tableData)

      // Получаем заголовки из первого объекта
      const headers = Object.keys(flatData[0])

      // Создаем CSV строку
      let csvContent = '\uFEFF' // UTF-8 BOM для корректного отображения кириллицы в Excel

      // Добавляем заголовки
      csvContent += headers.join(';') + '\n'

      // Добавляем данные
      flatData.forEach(row => {
        const values = headers.map(header => {
          const value = row[header] || ''
          // Экранируем кавычки и переносы строк
          return `"${String(value).replace(/"/g, '""')}"`
        })
        csvContent += values.join(';') + '\n'
      })

      // Создаем Blob и скачиваем
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)

      // Формируем имя файла
      const courseType = form?.values?.course_type === 0 ? 'Основное' :
                        form?.values?.course_type === 1 ? 'Дополнительное' : 'Внеурочная'
      const fileName = `Структура_предмета_${courseType}_${new Date().toLocaleDateString()}.csv`

      link.setAttribute('href', url)
      link.setAttribute('download', fileName)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Ошибка при экспорте:', error)
      alert('Ошибка при экспорте данных')
    }
  }

  const importFromExcel = () => {
    filePicker.current.click()
  }

  const handleFileChange = async (e) => {
    const file = e.target.files[0]
    if (!file) return

    if (file.name.split('.').pop() !== 'csv') {
      alert('Поддерживается только формат CSV')
      return
    }

    try {
      const text = await file.text()
      // Удаляем BOM если есть
      const content = text.replace(/^\uFEFF/, '')
      const lines = content.split('\n').filter(line => line.trim())

      if (lines.length < 2) {
        alert('Файл пустой или содержит только заголовки')
        return
      }

      alert('Импорт из Excel будет реализован в следующей версии')
      // TODO: Реализовать парсинг CSV и построение иерархии
    } catch (error) {
      console.error('Ошибка при импорте:', error)
      alert('Ошибка при чтении файла')
    }

    // Сбрасываем значение input для возможности повторного выбора того же файла
    e.target.value = ''
  }
  // ............Excel.................

  return (
    <footer className={styles.footer} ref={buttonsBlockRef}>
      <div>
        <Button
          className={styles.footerButton}
          mode='bordered'
          onClick={() => createRow('new')}
        >
          <p title="Добавить дисциплину">
            +
          </p>
        </Button>
        <Button
          className={styles.footerButton}
          mode='bordered'
          onClick={() => createRow()}
          disabled={!canAddChild}
        >
          <p title={selectedRow && !canAddChild
            ? 'Сначала сохраните этот элемент, затем добавьте дочерний'
            : 'Добавить дочернюю дисциплину'}>
            + ↴
          </p>
        </Button>
        <Button
          className={styles.footerButton}
          mode='bordered'
          onClick={deleteRow}
          disabled={!selectedRow}
        >
          <p title="Удалить">
            -
          </p>
        </Button>
        <Button
          className={styles.footerButton}
          mode='bordered'
          onClick={() => editRow('up')}
          disabled={!selectedRow}
        >
          <p title="Подняться вверх">
            ⭡
          </p>
        </Button>
        <Button
          className={styles.footerButton}
          mode='bordered'
          onClick={() => editRow('down')}
          disabled={!selectedRow}
        >
          <p title="Спуститься вниз">
            ⭣
          </p>
        </Button>
        <Button
          className={styles.footerButton}
          mode='bordered'
          disabled={true}
        >
          <p title="Спуститься на уровень вниз">
            ⬎
          </p>
        </Button>
        <Button
          className={styles.footerButton}
          mode='bordered'
          disabled={true}
        >
          <p title="Подняться на уровень вверх">
            ⬏
          </p>
        </Button>
        <Button
          className={styles.footerButton}
          mode='bordered'
          onClick={importFromExcel}
        >
          Импорт из Excel
        </Button>
        <Button
          className={styles.footerButton}
          mode='bordered'
          onClick={exportToExcel}
          disabled={!tableData || tableData.length === 0}
        >
          Экспорт в Excel
        </Button>
        <input
          className={styles.hidden}
          type='file'
          ref={filePicker}
          onChange={handleFileChange}
          accept=".csv"
        />
      </div>

      <div>
        <Button mode='white' onClick={saveData}>Сохранить</Button>
        <Button mode='white' onClick={goBack}>Закрыть</Button>
      </div>
    </footer>
  )
}

